import { render, staticRenderFns } from "./WaiterListDownload.vue?vue&type=template&id=7b1fe8c5&scoped=true&lang=pug"
import script from "./WaiterListDownload.vue?vue&type=script&lang=ts"
export * from "./WaiterListDownload.vue?vue&type=script&lang=ts"
import style0 from "./WaiterListDownload.vue?vue&type=style&index=0&id=7b1fe8c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1fe8c5",
  null
  
)

export default component.exports